import { ServiceClient } from 'src/utils'
import type { Editor, Template, Uso } from './Templates.scopes'

const serviceClient = ServiceClient.singleton()

const BASE_URL = '/api/templates'

export class TemplatesService {
    static #INSTANCE = new TemplatesService()
    static readonly singleton = () => TemplatesService.#INSTANCE

    async listar(atualizar: boolean): Promise<Template[]> {
        return serviceClient.authGet<Template[]>(`${BASE_URL}?atualizar=${atualizar}`)
    }

    async usos(atualizar: boolean): Promise<Uso[]> {
        return serviceClient.authGet<Uso[]>(`${BASE_URL}/usos?atualizar=${atualizar}`)
    }

    async criar(e: Editor): Promise<Template> {
        return serviceClient.authPost<Template>(BASE_URL, {
            nome: e.nome,
            categoria: e.categoria,
            idioma: e.idioma,
            corpo: e.corpo,
            exemplos: e.exemplos,
            botoes: e.botoes
        })
    }

    async editar(e: Editor): Promise<void> {
        await serviceClient.authPost(`${BASE_URL}/${e.templateId}/editar`, {
            corpo: e.corpo,
            exemplos: e.exemplos,
            botoes: e.botoes
        })
    }

    async excluir(id: string): Promise<void> {
        await serviceClient.authDelete(`${BASE_URL}/${encodeURIComponent(id)}`)
    }

    async ligar(uso: string, template: string, idioma: string): Promise<Uso> {
        return serviceClient.authPost<Uso>(`${BASE_URL}/usos/${uso}`, { template, idioma })
    }
}

export default TemplatesService.singleton()
